import { useTranslation } from 'react-i18next';
import BrandLogo from '../brand/BrandLogo';
import NotificationBell from '../notifications/NotificationBell';
import HeaderSignOutButton from './HeaderSignOutButton';
import SalonSwitcher from './SalonSwitcher';
import LanguageSwitcher from '../ui/LanguageSwitcher';
import ThemeToggle from '../ui/ThemeToggle';
import ViewModeToggle from './ViewModeToggle';

const AppHeader = ({ onMenuClick, menuOpen, title }) => {
  const { t } = useTranslation();

  return (
    <header className="sticky top-0 z-30 flex min-w-0 items-center justify-between gap-2 border-b border-zinc-200 bg-zinc-50/95 px-3 py-3 backdrop-blur dark:border-aura-800/80 dark:bg-[#07040f]/95 sm:gap-4 sm:px-4 md:px-6">
      <div className="flex min-w-0 items-center gap-2 sm:gap-3">
        <button
          type="button"
          onClick={onMenuClick}
          className="shrink-0 rounded-lg p-2 text-zinc-600 hover:bg-zinc-100 dark:text-zinc-400 dark:hover:bg-zinc-800"
          aria-label={menuOpen ? t('common.closeMenu') : t('common.openMenu')}
          aria-expanded={!!menuOpen}
        >
          ☰
        </button>
        <BrandLogo to="/" size="sm" showWordmark className="min-w-0" />
        {title && (
          <>
            <span
              className="hidden h-5 w-px shrink-0 bg-zinc-200 dark:bg-aura-800/80 sm:block"
              aria-hidden
            />
            <h1 className="hidden truncate text-base font-semibold text-zinc-900 dark:text-zinc-100 sm:block sm:text-lg">
              {title}
            </h1>
          </>
        )}
      </div>
      <div className="flex min-w-0 flex-wrap items-center justify-end gap-1.5 sm:gap-2 md:gap-3">
        <div className="hidden lg:block">
          <ViewModeToggle />
        </div>
        <SalonSwitcher />
        <div className="hidden md:flex md:items-center md:gap-3">
          <LanguageSwitcher />
          <ThemeToggle />
        </div>
        <NotificationBell />
        <div className="hidden sm:block">
          <HeaderSignOutButton />
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
